/* OKCA.render: tarjetas v3 de compra asistida (hero, card, samples, trust). Devuelve HTML en string. */
(function () {
  'use strict';
  window.OKCA = window.OKCA || {};

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  // Precio y textos en el idioma de la tienda (los pone la sección: window.OKCA_MONEY y window.OKCA_T).
  function money(c) {
    if (typeof window.OKCA_MONEY === 'function') return window.OKCA_MONEY(Number(c || 0));
    return (Number(c || 0) / 100).toFixed(2).replace('.', ',') + ' €';
  }
  function T(k, d, v) { var t = window.OKCA_T || {}, s = t[k] || d; if (v) for (var x in v) s = s.split('{' + x + '}').join(v[x]); return s; }
  function nrm(x) { return String(x || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }
  // Las notas se ELIGEN sobre la ficha en español (okca-notes.js busca palabras en español) y se ENSEÑAN en el
  // idioma de la tienda: misma posición en la lista traducida (p.sL/p.cL/p.fL, las trae la sección).
  function enIdioma(p, part, name) {
    var es = String(p[part] || '').split(','), tr = p[part + 'L'] ? String(p[part + 'L']).split(',') : null;
    if (!tr || tr.length !== es.length) return name;
    for (var i = 0; i < es.length; i++) {
      if (nrm(es[i]).indexOf(nrm(name)) >= 0 && tr[i]) {
        var t = tr[i].replace(/\.\s*$/, '').trim();
        return t.charAt(0).toUpperCase() + t.slice(1);
      }
    }
    return name;
  }
  function noteApi(fn, p, def) {
    var v = def;
    try { var n = window.OKCA.notes; if (n && typeof n[fn] === 'function') { v = n[fn](p); if (v == null) v = def; } } catch (e) {}
    if (fn === 'key' && v && v.length) v = v.map(function (it) {
      var o = {}; for (var k in it) o[k] = it[k];
      o.name = enIdioma(p, it.part, it.name);
      return o;
    });
    if (fn === 'top2' && v && v.length) v = v.map(function (nm) {
      var r = enIdioma(p, 's', nm); if (r === nm) r = enIdioma(p, 'f', nm); if (r === nm) r = enIdioma(p, 'c', nm); return r;
    });
    return v;
  }

  // ---- CSS (una sola vez) ----
  var CSS = '' +
  '.okcr-hero,.okcr-card,.okcr-samples{--noir:#1C1A18;--gold:#B89860;--goldt:#7A6235;--soft:#E9D9B6;--cream:#F6EFE3;--coral:#e4593e;--muted:#6B635A;--line:#E4DACB;}' +
  '.okcr-hero button,.okcr-card button,.okcr-samples button{font-family:inherit;}' +
  /* hero */
  '.okca__card.okcr-hero{display:block;container-type:inline-size;background:#1C1A18;border:0;border-radius:20px;box-shadow:0 18px 40px rgba(28,26,24,.18);color:#F6EFE3;overflow:hidden;}' +
  '.okcr-hero__in{display:flex;flex-direction:column;height:100%;}' +
  '.okcr-hero__img{display:block;height:230px;background:#F6EFE3;overflow:hidden;}' +
  '.okcr-hero__img img{width:100%;height:100%;object-fit:cover;display:block;}' +
  '.okcr-hero__body{display:flex;flex-direction:column;gap:14px;padding:20px;min-width:0;}' +
  '.okcr-hero__top{display:flex;align-items:flex-start;justify-content:space-between;gap:12px;}' +
  '.okcr-eyebrow{display:flex;align-items:center;gap:7px;font-size:10.5px;font-weight:700;letter-spacing:.14em;text-transform:uppercase;color:#B89860;}' +
  '.okcr-eyebrow svg{width:12px;height:12px;flex:none;}' +
  '.okcr-hero__code{display:block;margin:6px 0 2px;font-family:"Cormorant Garamond",Georgia,serif;font-weight:600;font-size:50px;line-height:.95;color:#F6EFE3;text-decoration:none;}' +
  '.okcr-hero__ref{margin:0;font-size:14px;line-height:1.4;color:#CFC6B8;}' +
  '.okcr-ring{position:relative;flex:none;width:56px;height:56px;}' +
  '.okcr-ring svg{width:56px;height:56px;transform:rotate(-90deg);display:block;}' +
  '.okcr-ring circle{fill:none;stroke-width:3;}' +
  '.okcr-ring__bg{stroke:rgba(233,217,182,.18);}' +
  '.okcr-ring__fg{stroke:#B89860;stroke-linecap:round;}' +
  '.okcr-ring__n{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;font-size:14px;font-weight:700;color:#F6EFE3;font-variant-numeric:tabular-nums;}' +
  '.okcr-ring__n small{font-size:8px;font-weight:600;margin-left:1px;margin-top:-4px;color:#CFC6B8;}' +
  '.okcr-notes{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:8px;padding:14px 0;border-top:1px solid rgba(233,217,182,.15);border-bottom:1px solid rgba(233,217,182,.15);}' +
  '.okcr-note{display:flex;flex-direction:column;align-items:center;gap:7px;text-align:center;min-width:0;}' +
  '.okcr-note__ic{width:34px;height:34px;border-radius:50%;border:1px solid rgba(233,217,182,.35);display:flex;align-items:center;justify-content:center;color:#E9D9B6;}' +
  '.okcr-note__ic svg{width:18px;height:18px;display:block;stroke:currentColor;}' +
  '.okcr-note__l{display:block;font-size:10.5px;font-weight:600;letter-spacing:.14em;text-transform:uppercase;color:#9A8F82;line-height:1.2;}' +
  '.okcr-note__n{display:block;margin-top:3px;font-size:13px;color:#F6EFE3;line-height:1.25;overflow-wrap:anywhere;}' +
  '.okcr-meta{margin:0;font-size:12px;color:#B8AE9F;}' +
  '.okcr-meta i{font-style:normal;color:#B89860;}' +
  '.okcr-meta b{color:#F6EFE3;font-weight:700;}' +
  '.okcr-buy{display:flex;gap:10px;align-items:stretch;}' +
  '.okcr-size{display:flex;flex:none;gap:2px;padding:3px;border:1px solid rgba(233,217,182,.35);border-radius:12px;background:rgba(255,255,255,.04);}' +
  '.okcr-size button{border:0;background:transparent;color:#B8AE9F;font-size:12px;font-weight:600;letter-spacing:.02em;padding:0 13px;min-height:44px;border-radius:9px;cursor:pointer;white-space:nowrap;-webkit-tap-highlight-color:transparent;transition:background-color .18s cubic-bezier(.23,1,.32,1),color .18s cubic-bezier(.23,1,.32,1),transform .14s cubic-bezier(.23,1,.32,1);}' +
  '.okcr-size button:active{transform:scale(.96);}' +
  '.okcr-size button[aria-pressed="true"]{background:#E9D9B6;color:#1C1A18;box-shadow:0 1px 2px rgba(0,0,0,.25);}' +
  '.okcr-add{flex:1;display:flex;align-items:center;justify-content:center;min-height:52px;padding:0 14px;border:0;border-radius:12px;background:#e4593e;color:#fff;font-size:14px;font-weight:700;letter-spacing:.05em;text-decoration:none;cursor:pointer;font-variant-numeric:tabular-nums;transition:filter .2s,transform .12s;}' +
  '.okcr-add:focus-visible,.okcr-size button:focus-visible,.okca__samples.okcr-samples button:focus-visible{outline:2px solid #E9D9B6;outline-offset:2px;}' +
  '.okcr-plus:focus-visible,.okcr-card__code:focus-visible{outline:2px solid #7A6235;outline-offset:2px;}' +
  '.okcr-add:active{transform:scale(.98);}' +
  '.okcr-add[disabled]{opacity:.6;cursor:default;}' +
  '@media (hover:hover){.okcr-add:hover{filter:brightness(1.06);}.okcr-size button[aria-pressed="false"]:hover{color:#F6EFE3;}}' +
  '@container (min-width:520px){' +
    '.okcr-hero__in{flex-direction:row;align-items:stretch;}' +
    '.okcr-hero__img{flex:0 0 44%;height:auto;position:relative;min-height:320px;}.okcr-hero__img img{position:absolute;inset:0;}' +
    '.okcr-hero__body{flex:1;padding:26px 28px;justify-content:center;}' +
    '.okcr-hero__code{font-size:64px;}' +
  '}' +
  /* card */
  '.okca__card.okcr-card{background:#fff;border:0;border-radius:16px;overflow:hidden;position:relative;box-shadow:0 0 0 1px #EADFCB,0 16px 28px -22px rgba(80,55,20,.35);transition:box-shadow .25s cubic-bezier(.23,1,.32,1);}' +
  '@media (hover:hover){.okca__card.okcr-card:hover{box-shadow:0 0 0 1px #D9CBB0,0 18px 32px -18px rgba(80,55,20,.4);}}' +
  '.okcr-card__code::after{content:"";position:absolute;inset:0;z-index:1;}' +
  '.okcr-card__code{position:static;}' +
  '.okcr-card__img{display:block;aspect-ratio:1/1;margin:8px 8px 0;border-radius:11px;background:#F6EFE3;overflow:hidden;}' +
  '.okcr-card__img img{width:100%;height:100%;object-fit:cover;display:block;transition:transform .5s cubic-bezier(.23,1,.32,1);}' +
  '@media (hover:hover){.okcr-card:hover .okcr-card__img img{transform:scale(1.04);}}' +
  '.okcr-pct{position:absolute;top:8px;left:8px;z-index:1;padding:4px 8px;border-radius:999px;background:rgba(255,255,255,.94);font-size:10.5px;font-weight:700;color:#7A6235;letter-spacing:.02em;box-shadow:0 2px 8px rgba(28,26,24,.08);}' +
  '.okcr-card__body{display:flex;flex-direction:column;gap:8px;padding:11px 11px 12px;flex:1;min-width:0;}' +
  '.okcr-card__code + .okcr-card__ref{margin-top:-5px;}' +
  '.okcr-card__code{font-family:"Cormorant Garamond",Georgia,serif;font-weight:600;font-size:26px;line-height:1;color:#1C1A18;text-decoration:none;}' +
  '.okcr-card__ref{font-size:12.5px;font-weight:500;line-height:1.35;color:#1C1A18;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;white-space:normal;min-height:2.7em;}' +
  '.okcr-card__ref em,.okcr-hero__ref em{font-family:"Cormorant Garamond",Georgia,serif;font-style:italic;font-size:1.12em;font-weight:600;color:#7A6235;}' +
  '.okcr-hero__ref em{color:#C9AE7E;}' +
  '.okcr-pills{display:flex;flex-wrap:wrap;gap:5px;margin-top:2px;min-height:21px;}' +
  '.okcr-pills span{padding:3px 8px;border-radius:999px;background:#F6EFE3;color:#7A6235;font-size:10.5px;font-weight:600;line-height:1.3;}' +
  '.okcr-card__foot{margin-top:auto;padding-top:8px;display:flex;align-items:center;justify-content:space-between;gap:8px;}' +
  '.okcr-price{font-size:14px;font-weight:700;color:#1C1A18;font-variant-numeric:tabular-nums;}' +
  '.okcr-plus{position:relative;flex:none;width:44px;height:44px;z-index:2;border:0;border-radius:50%;background:#1C1A18;color:#F6EFE3;cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0;transition:background-color .2s,transform .12s;}' +
  '.okcr-plus::before{content:"";position:absolute;inset:-2px;}' +
  '.okcr-plus svg{width:16px;height:16px;display:block;}' +
  '.okcr-plus:active{background:#000;}' +
  '.okcr-plus:active{transform:scale(.92);}' +
  '.okcr-plus[disabled]{opacity:.6;cursor:default;}' +
  '@media (hover:hover){.okcr-plus:hover{background:#3A3530;}}' +
  '@media (min-width:601px){.okcr-card__code{font-size:30px;}.okcr-card__body{padding:13px 14px 14px;}}' +
  /* huella */
  '.okcr-hu{display:flex;flex-direction:column;gap:6px;min-width:0;}' +
  '.okcr-hu__bar{display:flex;gap:2px;height:6px;border-radius:99px;overflow:hidden;animation:okcrHu .6s cubic-bezier(.23,1,.32,1) .12s both;}' +
  '.okcr-hu__bar i{display:block;height:100%;}' +
  '.okcr-hu__l{display:flex;flex-wrap:wrap;gap:2px 12px;font-size:11px;font-weight:500;color:#6B635A;}' +
  '.okcr-hu__l span{display:inline-flex;align-items:center;gap:5px;white-space:nowrap;}' +
  '.okcr-hu__l span i{width:7px;height:7px;border-radius:50%;flex:none;}' +
  '.okcr-hu__h{font-size:10.5px;font-weight:600;letter-spacing:.14em;text-transform:uppercase;color:#9A8F82;}' +
  '.okcr-hero .okcr-hu__bar{height:8px;}' +
  '.okcr-hero .okcr-hu__l{font-size:12px;color:#CFC6B8;}' +
  '@keyframes okcrHu{from{clip-path:inset(0 100% 0 0 round 99px);}to{clip-path:inset(0 0 0 0 round 99px);}}' +
  /* muestras */
  '.okca__samples.okcr-samples{grid-column:1/-1;display:flex;align-items:center;gap:18px;flex-wrap:wrap;padding:18px;border-radius:14px;background:#F6EFE3;border:0;}' +
  '.okcr-bottles{display:flex;align-items:flex-end;gap:0;flex:none;padding:10px 10px 6px;border-radius:12px;background:radial-gradient(120% 90% at 30% 20%,#FFFBF4 0%,#F1E6D4 70%,#EADCC6 100%);}' +
  '.okcr-bottles svg{width:40px;height:114px;display:block;}' +
  '.okcr-bottles svg:nth-child(2){transform:translateY(-4px);}' +
  '.okcr-samples__t{flex:1 1 240px;min-width:0;}' +
  '.okcr-samples__title{display:block;font-family:"Cormorant Garamond",Georgia,serif;font-weight:600;font-size:21px;line-height:1.15;color:#1C1A18;}' +
  '.okcr-samples__sub{display:block;margin-top:3px;font-size:13px;line-height:1.4;color:#6B635A;}' +
  '.okca__samples.okcr-samples button{min-height:44px;padding:0 22px;border-radius:999px;border:1px solid #1C1A18;background:#1C1A18;color:#F6EFE3;font-size:13px;font-weight:700;letter-spacing:.04em;cursor:pointer;white-space:nowrap;}' +
  '.okca__samples.okcr-samples button[disabled]{opacity:.6;}' +
  '@media (max-width:600px){.okca__samples.okcr-samples{display:grid;grid-template-columns:auto minmax(0,1fr);align-items:center;padding:16px;gap:14px;}.okcr-samples__t{flex:none;}.okcr-bottles{padding:8px 6px 4px;}.okcr-bottles svg{width:32px;height:92px;}.okcr-samples__title{font-size:19px;}.okca__samples.okcr-samples button{grid-column:1/-1;width:100%;}}' +
  /* confianza */
  '.okcr-trust{display:flex;justify-content:center;gap:clamp(18px,6vw,56px);padding:16px 8px;border-top:1px solid #E4DACB;border-bottom:1px solid #E4DACB;margin:22px 0 0;}' +
  '.okcr-trust div{display:flex;flex-direction:column;align-items:center;text-align:center;gap:2px;}' +
  '.okcr-trust b{font-family:"Cormorant Garamond",Georgia,serif;font-weight:600;font-size:28px;font-variant-numeric:lining-nums;line-height:1.1;color:#1C1A18;}' +
  '.okcr-trust span{font-size:12px;line-height:1.3;color:#6B635A;}' +
  '@media (prefers-reduced-motion:reduce){.okcr-hu__bar{animation:none;}.okcr-card__img img,.okcr-add,.okcr-plus,.okcr-size button{transition:none;}.okcr-add:active,.okcr-plus:active{transform:none;}.okcr-card:hover .okcr-card__img img{transform:none;}}';

  function injectCss() {
    if (document.getElementById('okca-render-css')) return;
    var s = document.createElement('style');
    s.id = 'okca-render-css';
    s.appendChild(document.createTextNode(CSS));
    (document.head || document.documentElement).appendChild(s);
  }
  injectCss();

  var SPARK = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="currentColor" d="M12 1.5c.6 5.6 2.4 8.4 6.1 9.3l4.4 1.2-4.4 1.2c-3.7.9-5.5 3.7-6.1 9.3-.6-5.6-2.4-8.4-6.1-9.3L1.5 12l4.4-1.2c3.7-.9 5.5-3.7 6.1-9.3z"/></svg>';
  var PLUS = '<svg viewBox="0 0 14 14" aria-hidden="true" focusable="false"><path d="M7 1.5v11M1.5 7h11" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" fill="none"/></svg>';

  function ring(pct) {
    var C = 2 * Math.PI * 24, off = C * (1 - Math.max(0, Math.min(100, pct)) / 100);
    return '<div class="okcr-ring" role="img" aria-label="' + esc(T('ring', 'Encaja un {n} %', { n: pct })) + '">' +
      '<svg viewBox="0 0 56 56" aria-hidden="true"><circle class="okcr-ring__bg" cx="28" cy="28" r="24"/>' +
      '<circle class="okcr-ring__fg" cx="28" cy="28" r="24" stroke-dasharray="' + C.toFixed(2) + '" stroke-dashoffset="' + off.toFixed(2) + '"/></svg>' +
      '<span class="okcr-ring__n" aria-hidden="true">' + esc(pct) + '<small>%</small></span></div>';
  }

  // HUELLA: de qué está hecho el perfume, con el mismo reparto entre familias con el que se puntúa (p._v, lo
  // calcula la sección). Sin porcentajes a la vista: es nuestra lectura de sus acordes y notas, no un dato
  // de la marca, y un «63 %» aparentaría una precisión que no tiene.
  var HU = { fresco: '#5E9E91', madera: '#8A6644', especiado: '#D08B5F', dulce: '#E0B472', floral: '#D7A1B0', frutal: '#C9B650' };
  var HU_ES = { fresco: 'Fresco', madera: 'Amaderado', especiado: 'Especiado', dulce: 'Dulce', floral: 'Floral', frutal: 'Frutal' };
  // «Recuerda a» (o su traducción) en cursiva dorada; el nombre, recto. Si el prefijo no casa, texto tal cual.
  function refHtml(s) {
    var m = String(s || '').match(/^(Recuerda a|Inspired by|Inspiré par|Inspirado em)\s+(.+)$/i);
    return m ? '<em>' + esc(m[1]) + '</em> ' + esc(m[2]) : esc(s);
  }
  function huella(p, nLab, conTitulo) {
    var v = p && p._v; if (!v) return '';
    var segs = Object.keys(HU).map(function (k) { return [k, v[k] || 0]; })
      .filter(function (x) { return x[1] >= 0.04; }).sort(function (a, b) { return b[1] - a[1]; });
    if (!segs.length) return '';
    var tot = segs.reduce(function (s, x) { return s + x[1]; }, 0) || 1;
    var bar = segs.map(function (x) { return '<i style="width:' + (100 * x[1] / tot).toFixed(1) + '%;background:' + HU[x[0]] + '"></i>'; }).join('');
    var lab = segs.slice(0, nLab).map(function (x) { return '<span><i style="background:' + HU[x[0]] + '"></i>' + esc(T('fam_' + x[0], HU_ES[x[0]])) + '</span>'; }).join('');
    var names = segs.slice(0, nLab).map(function (x) { return T('fam_' + x[0], HU_ES[x[0]]); }).join(', ');
    return '<div class="okcr-hu">' + (conTitulo ? '<span class="okcr-hu__h">' + esc(T('huella', 'Su huella')) + '</span>' : '') +
      '<div class="okcr-hu__bar" role="img" aria-label="' + esc(T('huella', 'Su huella') + ': ' + names) + '">' + bar + '</div>' +
      '<div class="okcr-hu__l" aria-hidden="true">' + lab + '</div></div>';
  }

  function notesRow(p) {
    var ks = noteApi('key', p, []) || [];
    if (!ks.length) return '';
    return '<div class="okcr-notes">' + ks.slice(0, 3).map(function (k) {
      return '<div class="okcr-note"><span class="okcr-note__ic">' + (k.icon || '') + '</span><div>' +
        '<span class="okcr-note__l">' + esc(k.label) + '</span><span class="okcr-note__n">' + esc(k.name) + '</span></div></div>';
    }).join('') + '</div>';
  }

  function ctaLabel(v) { return T('add', 'Añadir · {price}', { price: money(v.p) }); }

  function hero(r, opts) {
    var p = r.p, act = !!(opts && opts.act), rv = Number(p.rv || 0), rc = Number(p.rc || 0);
    var v100 = p._v100, v30 = p._v30, sel = v100 || v30;
    var dur = noteApi('duration', p, '');
    var code = p._code
      ? '<a class="okcr-hero__code" href="' + esc(p.u) + '">' + esc(p._code) + '</a>' + (p._ref ? '<p class="okcr-hero__ref">' + refHtml(p._ref) + '</p>' : '')
      : '<a class="okcr-hero__code" style="font-size:32px;line-height:1.05" href="' + esc(p.u) + '">' + esc(p.t) + '</a>';
    var meta = rc ? '<p class="okcr-meta"><i>★</i> <b>' + esc(window.OKCA_LOC === 'en' ? rv.toFixed(1) : rv.toFixed(1).replace('.', ',')) + '</b> · ' + esc(T('reviews', '{n} reseñas', { n: rc })) + '</p>' :
      '';
    var buy;
    if (sel) {
      var both = v100 && v30;
      buy = '<div class="okcr-buy">' +
        (both ? '<div class="okcr-size" role="group" aria-label="' + esc(T('size', 'Tamaño')) + '">' +
          '<button type="button" data-okcr-size="30" data-id="' + v30.id + '" data-p="' + v30.p + '" aria-pressed="false">30 mL</button>' +
          '<button type="button" data-okcr-size="100" data-id="' + v100.id + '" data-p="' + v100.p + '" aria-pressed="true">100 mL</button></div>' : '') +
        '<button type="button" class="okcr-add" data-add="' + sel.id + '">' + ctaLabel(sel) + '</button></div>';
    } else {
      buy = '<div class="okcr-buy"><a class="okcr-add" href="' + esc(p.u) + '">' + esc(T('view', 'Ver perfume')) + '</a></div>';
    }
    return '<li class="okca__card okca__card--best okcr-hero" data-key="' + esc(p.h) + '"><div class="okcr-hero__in">' +
      '<a class="okcr-hero__img" href="' + esc(p.u) + '" tabindex="-1" aria-hidden="true">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" width="600" height="600" loading="eager">' : '') + '</a>' +
      '<div class="okcr-hero__body">' +
        '<div class="okcr-hero__top"><div><span class="okcr-eyebrow">' + SPARK + esc(act ? T('hero_act', 'Si solo te llevas uno') : T('hero_top', 'El que más se lleva ahora')) + '</span>' + code + '</div>' +
          (r.pct > 0 ? ring(r.pct) : '') + '</div>' +
        huella(p, 3, true) + notesRow(p) + meta + buy +
      '</div></div></li>';
  }

  function card(r, opts) {
    var p = r.p, v = p._v100;
    var codeTxt = p._code || p.t;
    // El % solo en las que encajan claramente menos: un «98 %» en cada tarjeta no aporta nada.
    var badge = (r.pct && r.pct < 95) ? '<span class="okcr-pct">' + esc(r.pct) + ' %</span>' : '';
    return '<li class="okca__card okcr-card" data-key="' + esc(p.h) + '">' + badge +
      '<a class="okcr-card__img" href="' + esc(p.u) + '" tabindex="-1" aria-hidden="true">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" width="400" height="400" loading="lazy">' : '') + '</a>' +
      '<div class="okcr-card__body">' +
        '<a class="okcr-card__code" href="' + esc(p.u) + '"' + (p._code ? '' : ' style="font-size:20px;line-height:1.1"') + '>' + esc(codeTxt) + '</a>' +
        (p._code && p._ref ? '<span class="okcr-card__ref">' + refHtml(p._ref) + '</span>' : '') +
        huella(p, 2, false) +
        '<div class="okcr-card__foot">' +
          (v ? '<span class="okcr-price">' + money(v.p) + '</span>' +
            '<button type="button" class="okcr-plus" data-add="' + v.id + '" aria-label="' + esc(T('add_aria', 'Añadir {code} 100 mL, {price}', { code: codeTxt, price: money(v.p) })) + '">' + PLUS + '</button>'
            : '<a class="okcr-price" href="' + esc(p.u) + '">' + esc(T('view', 'Ver perfume')) + '</a>') +
        '</div>' +
      '</div></li>';
  }

  // VIAL DE MUESTRA dibujado a partir del real (pack-3-muestras): pulverizador de plástico transparente
  // con su tubito, cuello estriado, tubo de cristal grueso con fondo redondo y el perfume dentro, y la
  // etiqueta blanca con banda negra y el código en blanco, en letra gruesa como la impresa.
  var vialN = 0;
  // Medido sobre la foto real del pack: capuchón transparente con el botón, la cámara de la bomba y la
  // rosca; tubo de cristal con el muelle arriba, perfume casi invisible y etiqueta con banda negra.
  function bottle(code) {
    var id = 'okv' + (++vialN);
 var W=56, X=6;
 return '<svg viewBox="0 0 92 262" aria-hidden="true" focusable="false">'+
 '<defs>'+
  '<filter id="'+id+'f" x="-40%" y="-400%" width="180%" height="900%"><feGaussianBlur stdDeviation="2.8"/></filter>'+
  '<filter id="'+id+'k" x="-60%" y="-20%" width="220%" height="140%"><feGaussianBlur stdDeviation="2.4"/></filter>'+
  // cristal: muy claro, apenas un gris en el borde derecho
  '<linearGradient id="'+id+'g" x1="0" x2="1"><stop offset="0" stop-color="#fff" stop-opacity=".95"/><stop offset=".12" stop-color="#fff" stop-opacity=".25"/><stop offset=".55" stop-color="#fff" stop-opacity=".05"/><stop offset=".9" stop-color="#EAE3D8" stop-opacity=".35"/><stop offset="1" stop-color="#CFC4B4" stop-opacity=".7"/></linearGradient>'+
  // etiqueta y banda envolviendo un cilindro
  '<linearGradient id="'+id+'w" x1="0" x2="1"><stop offset="0" stop-color="#EFEBE4"/><stop offset=".18" stop-color="#fff"/><stop offset=".7" stop-color="#FBFAF7"/><stop offset="1" stop-color="#DDD6CB"/></linearGradient>'+
  '<linearGradient id="'+id+'b" x1="0" x2="1"><stop offset="0" stop-color="#2B2A28"/><stop offset=".2" stop-color="#161514"/><stop offset=".75" stop-color="#121110"/><stop offset="1" stop-color="#34312D"/></linearGradient>'+
 '</defs>'+
 // sombra de apoyo bajo la base (dentro del viewBox) y el reflejo dorado de la luz que cruza el cristal
 '<ellipse filter="url(#'+id+'f)" cx="34" cy="252" rx="29" ry="3" fill="#9A7F5A" fill-opacity=".5"/>'+
 '<g filter="url(#'+id+'k)" opacity=".7"><rect x="44" y="112" width="6" height="128" rx="3" fill="#FCE9BE"/></g>'+
 // capuchón
 '<rect x="'+X+'" y="4" width="'+W+'" height="96" rx="7" fill="url(#'+id+'g)"/>'+
 '<path d="M'+(X+W-.6)+' 11v86" stroke="#C9BEAE" stroke-width="1"/>'+
 '<path d="M'+X+' 11q0-7 7-7h'+(W-14)+'q7 0 7 7" fill="none" stroke="#DCD3C6" stroke-width=".9"/>'+
 '<circle cx="34" cy="40" r="4.2" fill="#fff" fill-opacity=".8" stroke="#D2C8B9" stroke-width=".8"/>'+
 '<rect x="14" y="26" width="40" height="52" rx="3" fill="#fff" fill-opacity=".22" stroke="#E0D8CB" stroke-width=".8"/>'+
 '<rect x="14" y="60" width="40" height="5" fill="#B3A998" fill-opacity=".55"/>'+
 '<path d="M'+(X+2)+' 82h'+(W-4)+'M'+(X+2)+' 86h'+(W-4)+'M'+(X+2)+' 90h'+(W-4)+'M'+(X+2)+' 94h'+(W-4)+'M'+(X+2)+' 98h'+(W-4)+'" stroke="#E0D8CC" stroke-width="1"/>'+
 '<path d="M11 14v82" stroke="#fff" stroke-width="3.6" stroke-linecap="round"/>'+
 // tubo
 '<rect x="'+X+'" y="100" width="'+W+'" height="156" rx="9" fill="url(#'+id+'g)"/>'+
 '<path d="M'+(X+W-.6)+' 104v143" stroke="#C6BBAA" stroke-width="1"/>'+
 '<path d="M'+X+' 247q0 9 9 9h'+(W-18)+'q9 0 9-9" fill="none" stroke="#D3C9BA" stroke-width=".9"/>'+
 '<path d="M'+X+' 100.5h'+W+'" stroke="#D2C7B7" stroke-width="1"/>'+
 '<path d="M12.5 104v146M55.5 104v146" stroke="#E7E0D4" stroke-width="1"/>'+
 '<rect x="13" y="118" width="42" height="134" rx="5" fill="#F3E8D2" fill-opacity=".16"/>'+
 '<path d="M34 104v146" stroke="#E5DDD0" stroke-width="1"/>'+
 '<path d="M29.5 106l9 3-9 3 9 3-9 3 9 3-9 3 9 3-9 3" fill="none" stroke="#B5AA9A" stroke-width="1.2" stroke-linejoin="round"/>'+
 '<path d="M11 108v142" stroke="#fff" stroke-width="4" stroke-linecap="round"/>'+
 '<path d="M21 112v134" stroke="#fff" stroke-width="1" stroke-linecap="round" opacity=".7"/>'+
 '<path d="M57 112v134" stroke="#fff" stroke-width="1.2" stroke-linecap="round" opacity=".55"/>'+
 // etiqueta
 '<rect x="'+X+'" y="140" width="'+W+'" height="64" fill="url(#'+id+'w)"/>'+
 '<rect x="'+X+'" y="152" width="'+W+'" height="40" fill="url(#'+id+'b)"/>'+
 '<text x="34.5" y="179.5" text-anchor="middle" font-family="Montserrat,Arial Black,Arial,sans-serif" font-weight="900" font-size="20.5" letter-spacing=".5" fill="#fff">' + esc(code) + '</text>'+
 '<path d="M9 141v62" stroke="#fff" stroke-width="1.6" opacity=".55"/>'+
 '</svg>';
}

  function listaY(a) { return a.length < 2 ? (a[0] || '') : a.slice(0, -1).join(', ') + ' ' + T('and', 'y') + ' ' + a[a.length - 1]; }

  function samples(top, info) {
    if (!info || !info.available || !top || top.length < 3) return '';
    var codes = top.slice(0, 3).map(function (r) { return r.p._code || String(r.p.t || '').slice(0, 3); });
    var bots = codes.map(bottle).join('');
    return '<li class="okca__samples okcr-samples" data-key="__muestras">' +
      '<div class="okcr-bottles" aria-hidden="true">' + bots + '</div>' +
      '<div class="okcr-samples__t"><span class="okcr-samples__title">' + esc(T('s_title', 'No hace falta elegir todavía')) + '</span>' +
      '<span class="okcr-samples__sub">' + esc(T('s_sub', 'Te mandamos {codes} en muestras de 2 mL y te quedas con el que más te guste.', { codes: listaY(codes) })) + '</span></div>' +
      '<button type="button" data-samples>' + esc(T('s_btn', 'Las 3 muestras por {price}', { price: money(info.price) })) + '</button></li>';
  }

  function trust() {
    return '<div class="okcr-trust">' +
      '<div><b>' + esc(T('t1b', '+150.000')) + '</b><span>' + esc(T('t1', 'ya lo han probado')) + '</span></div>' +
      '<div><b>' + esc(T('t2b', '60 días')) + '</b><span>' + esc(T('t2', 'para cambiar de idea')) + '</span></div>' +
      '<div><b>24–48 h</b><span>' + esc(T('t3', 'y lo tienes en casa')) + '</span></div></div>';
  }

  // Selector de tamaño del hero (un único listener delegado)
  if (!window.__okcrSizeBound) {
    window.__okcrSizeBound = true;
    document.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-okcr-size]') : null;
      if (!t) return;
      var wrap = t.parentNode, btns = wrap.querySelectorAll('[data-okcr-size]'), i;
      for (i = 0; i < btns.length; i++) btns[i].setAttribute('aria-pressed', btns[i] === t ? 'true' : 'false');
      var buy = wrap.parentNode, add = buy && buy.querySelector('.okcr-add');
      if (add && add.tagName === 'BUTTON') {
        add.setAttribute('data-add', t.getAttribute('data-id'));
        add.textContent = ctaLabel({ p: Number(t.getAttribute('data-p')) });
      }
    });
  }

  window.OKCA.render = { hero: hero, card: card, samples: samples, trust: trust };
})();
